import "./style.css";
import Api from "@/components/Api";

export default class Profile {
  static selector = ".profile-page";

  constructor(block) {
    this.block = block;

    this.passwordResetButton = this.block.querySelector(
      ".profile-page__password-reset-cta"
    );

    this.payButton = this.block.querySelector(".profile-page__payment-button");
  }

  handlePasswordResetClick = () => {
    window.App.modals.login.open();
  };

  handleMembershipPayment = async () => {
    this.payButton.classList.add("profile-page__payment-button--loading");

    try {
      const res = await Api.createPayment();
      if (res.redirectUrl) {
        // redirect to payment gateway
        window.location.href = res.redirectUrl;
      }
    } catch (error) {
      console.log("Error from api: ", error);
    }

    this.payButton.classList.remove("profile-page__payment-button--loading");
  };

  onReady() {
    if (this.passwordResetButton) {
      this.passwordResetButton.addEventListener(
        "click",
        this.handlePasswordResetClick
      );
    }

    if (this.payButton) {
      this.payButton.addEventListener("click", this.handleMembershipPayment);
    }
  }

  onResize() {}

  onDestroy() {
    if (this.passwordResetButton) {
      this.passwordResetButton.removeEventListener(
        "click",
        this.handlePasswordResetClick
      );
    }

    if (this.payButton) {
      this.payButton.removeEventListener("click", this.handleMembershipPayment);
    }
  }
}
